import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AnalyticsEvent, pushPlausibleEvent } from 'utils/analytics';

import { CarouselTypes } from '../../consts';

const Step = ({
    styles,
    isCurrent,
    order,
    isLast,
    slideId,
    navigationTitle,
    moveToSlideId,
    handleHover,
    hoverTitle,
    type,
    currentCarouselSlide,
}) => {
    const handleClick = e => {
        e.stopPropagation();
        moveToSlideId && moveToSlideId(slideId);
        pushPlausibleEvent(AnalyticsEvent.CAROUSEL_NUMBER_CLICK, {
            click_text: hoverTitle,
            click_number: slideId + 1,
            current_carousel_slide: currentCarouselSlide,
            // TODO: add missing carousel type property
        });
    };

    const handleMouseHover = value => {
        if (type === CarouselTypes.PROCESS || (type === CarouselTypes.WORKSHOP_PROCESS && handleHover)) {
            handleHover(value);
        }
    };

    const containerProps = {
        onClick: handleClick,
        className: styles.button,
        role: 'button',
        onKeyDown: handleClick,
        onMouseEnter: () => handleMouseHover(false),
        onMouseLeave: () => handleMouseHover(true),
    };

    const children = (
        <span className={isCurrent ? styles.number : styles.step}>
            {navigationTitle ? <FormattedMessage id={navigationTitle} /> : isCurrent && order}
            {hoverTitle && (
                <span className={styles.hoverTitle}>
                    <FormattedMessage id={hoverTitle} />
                </span>
            )}
        </span>
    );

    return (
        <>
            {React.createElement(navigationTitle ? 'h3' : 'span', containerProps, children)}
            {!isLast && <span className={styles.line} />}
        </>
    );
};

Step.propTypes = {
    styles: PropTypes.shape({
        number: PropTypes.string.isRequired,
        step: PropTypes.string.isRequired,
        line: PropTypes.string.isRequired,
    }).isRequired,
    isCurrent: PropTypes.bool.isRequired,
    order: PropTypes.number.isRequired,
    isLast: PropTypes.bool.isRequired,
    slideId: PropTypes.number.isRequired,
    nextSlide: PropTypes.func.isRequired,
    navigationTitle: PropTypes.string,
    handleHover: PropTypes.func,
    moveToSlideId: PropTypes.func,
    currentCarouselSlide: PropTypes.string.isRequired,
};

Step.defaultProps = {
    navigationTitle: null,
    handleHover: null,
    moveToSlideId: null,
};

export default Step;
